import React from "react";
import { View, Platform, StyleSheet, ScrollView, Text } from "react-native";

import Header from "../../../common/header/index";
import appStyles from "../../../../appStyles";
import appPages from "../../../../../appPages";
import AppTheme from "../../../AppTheme";
import ManaButton from "../../../common/ManaButton";
import CopyWidget from "../../common/CopyWidget";

export default function Disconnect({
  showDisconnectPage = () => {},
  disconnectAccount = () => {},
  confirmUninstall = () => {},
}) {
  const url = "chrome://extensions/";

  return (
    <View style={[appStyles.container, { backgroundColor: "#FFF" }]}>
      <Header
        title="Disconnect Chrome"
        subTitle="Remove insights from your browsing activity"
        goBack={() => showDisconnectPage(null)}
        returnPage={appPages.integrationsV2}
      />

      <ScrollView
        style={(appStyles.scrollView, { paddingHorizontal: 16 })}
        contentContainerStyle={appStyles.scrollViewContent}
      >
        <Text style={styles.sectionText}>Sorry to see you go!</Text>
        <Text style={styles.label}>Turn Off Extension:</Text>

        <Text style={styles.text}>
          Turning off the extension means we don’t receive any data, & you can
          reactivate at any time.
        </Text>

        <ManaButton
          isMainButton
          onPress={disconnectAccount}
          text="Turn Off Integration"
          style={styles.button}
          styleText={styles.buttonText}
        />

        <Text style={styles.label}>Or, Uninstall:</Text>
        <Text style={[styles.text]}>
          Copy the link below into your browser:
        </Text>

        <CopyWidget
          text={url}
          style={{
            marginTop: 8,
            marginBottom: 16,
          }}
        />

        <Text style={styles.text}>
          2. Scroll down until you see Mana, click “Remove,” and confirm that
          you want to remove it from your browser.
        </Text>
        <Text style={styles.text}>3. When finished, tap the button below</Text>

        <ManaButton
          onPress={confirmUninstall}
          text="I’ve removed Chrome from my browser"
          style={styles.button}
          styleText={styles.buttonText}
        />
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  label: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: "#8B92A1",
    marginBottom: 8,
    marginTop: 16,
  },
  text: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
  },
  linkText: {
    color: AppTheme.DEFAULT_COLOR,
    fontWeight: "600",
    marginBottom: 8,
  },
  sectionText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1,
    color: AppTheme.almostBlack,
    textAlign: "center",
    marginTop: 16,
  },
  button: {
    width: "100%",
    height: 32,
    marginBottom: 8,
    marginTop: 8,
  },
  buttonText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
  },
});
